import { Box, Icon } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const PaymentMethodSelect = Box.withConfig({
  backgroundColor: getDesignToken('background-card'),
  borderWidth: 1,
  borderColor: primitive.$greyFour,
  borderRadius: primitive.$borderRadius,
});

export const StyledAddNewCreditCardIcon = Icon.withConfig({
  variant: 'emptyCreditCard',
});

export const StyledAddPaymentMethodIcon = Icon.withConfig({ variant: 'addCard' });

export const ToggleWrapper = Box.withConfig({
  position: 'absolute',
  top: '$4',
  right: '$2',
});
